import React, { useRef } from "react";

const SolutionsSection = ({
  solutionRef,
  showCards,
  currentSlide,
  skipTransition,
  base,
  ext,
  totalSlides,
  cardStyle,
  rowStyle,
  imageStyle,
  onSlideReset,
}) => {
  const sliderRef = useRef(null);

  const handleTransitionEnd = () => {
    if (currentSlide === base.length && sliderRef.current) {
      onSlideReset();
    }
  };

  return (
    <div ref={solutionRef} className="solutions-section-wrapper">
      <div className="container">
        <h2 className="fw-bold text-center mb-5" style={{ color: "#011601" }}>
          Our Solutions
        </h2>

        <div
          className={`solutions-animation-wrapper ${
            showCards ? "solutions-slide-in" : ""
          }`}
        >
          <div
            className="d-flex"
            ref={sliderRef}
            style={{
              transform: `translateX(-${(100 / totalSlides) * currentSlide}%)`,
              width: `${totalSlides * 100}%`,
              transition: skipTransition
                ? "none"
                : "transform 0.8s ease-in-out",
            }}
            onTransitionEnd={handleTransitionEnd}
          >
            {base.map((s, i) => (
              <div
                key={i}
                className="px-2"
                style={{ width: `${100 / totalSlides}%` }}
              >
                <div className="card border-0 shadow-sm" style={cardStyle}>
                  <div
                    className="row align-items-stretch gap-2"
                    style={rowStyle}
                  >
                    <div className="col-md-7 d-flex flex-column justify-content-center">
                      <h5 className="fw-bold mb-1">{s.title}</h5>
                      {s.subtitle && (
                        <p className="fw-bold mb-1">{s.subtitle}</p>
                      )}
                      <p className="text-muted">{s.description}</p>
                    </div>
                    <div className="col-md-4 d-flex align-items-center justify-content-center">
                      <img
                        src={s.image}
                        alt={`${s.title} Illustration`}
                        className="img-fluid rounded"
                        style={imageStyle}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Cloned Slide */}
            <div className="px-2" style={{ width: `${100 / totalSlides}%` }}>
              <div className="card border-0 shadow-sm" style={cardStyle}>
                <div className="row align-items-stretch gap-2" style={rowStyle}>
                  <div className="col-md-7 d-flex flex-column justify-content-center">
                    <h5 className="fw-bold mb-1">{base[0].title}</h5>
                    {base[0].subtitle && (
                      <p className="fw-bold mb-1">{base[0].subtitle}</p>
                    )}
                    <p className="text-muted">{base[0].description}</p>
                  </div>
                  <div className="col-md-4 d-flex align-items-center justify-content-center">
                    <img
                      src={base[0].image}
                      alt="Cloned Slide"
                      className="img-fluid rounded"
                      style={imageStyle}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionsSection;
